import { render, staticRenderFns } from "./ChoseImportType.vue?vue&type=template&id=59e38487&"
import script from "./ChoseImportType.vue?vue&type=script&lang=js&"
export * from "./ChoseImportType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports